import React from "react";
import { Link } from "react-router-dom";
import { profile, social, timeline } from "./data";
import { GitHubIcon, LinkedInIcon, TwitterIcon } from "./Icons";
import RichText from "./RichText";
import portrait from "../static/images/cards/IMG_5656.jpg";

const Home = () => (
  <div className="container">
    <header className="home-header">
      <div className="portrait-wrapper">
        <img className="portrait" src={portrait} alt={profile.name} />
      </div>
      <div>
        <h1>{profile.name}</h1>
        <p className="tagline">{profile.tagline}</p>
        <div className="social-links">
          <a
            href={social.github}
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
          >
            <GitHubIcon />
          </a>
          <a
            href={social.linkedin}
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <LinkedInIcon />
          </a>
          <a
            href={social.twitter}
            target="_blank"
            rel="noreferrer"
            aria-label="Twitter"
          >
            <TwitterIcon />
          </a>
        </div>
        <p className="email-link">
          <a className="link" href={`mailto:${profile.email}`}>
            {profile.email}
          </a>
          {" · "}
          <Link className="link" to="/resume">
            Resume
          </Link>
        </p>
      </div>
    </header>

    <section>
      {profile.intro.map((line) => (
        <p className="body-text" key={line}>
          {line}
        </p>
      ))}
    </section>

    <section className="timeline">
      {timeline.map((item, index) => (
        <div className="timeline-item" key={`${item.title}-${item.date}`}>
          <div className="timeline-marker">
            {item.logo ? (
              <img className="timeline-logo" src={item.logo} alt="" />
            ) : (
              <div className="timeline-dot" />
            )}
            {index < timeline.length - 1 && <div className="timeline-line" />}
          </div>
          <div className="timeline-content">
            <span className="timeline-date">{item.date}</span>
            <h3>
              {item.href ? (
                <a href={item.href} target="_blank" rel="noreferrer">
                  {item.title}
                </a>
              ) : (
                item.title
              )}
            </h3>
            <p className="body-text">
              <RichText value={item.body} />
            </p>
          </div>
        </div>
      ))}
    </section>

    <footer>
      <span>
        © {new Date().getFullYear()} {profile.name}
      </span>
      <Link className="link" to="/resume">
        Resume
      </Link>
    </footer>
  </div>
);

export default Home;
